import actions from './actions'
import getters from './getters'
import mutations from './mutations'

const state = {
    status: {
        common: '',
        detail: ''
    },
    inOutDates: [],
    transferItems: [],
    splitedTransferResourceIds: [],
    checkboxModels: {},
    pageObj: {
        currentPage: 1,
        perPage: 500
    },
    lengthsOfTransferResourceIds: 0
}
export default {
    namespaced: true,
    state,
    actions,
    getters,
    mutations
}
